// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"64px"};